module.exports = __webpack_public_path__ + "img/inbox.fa3844e7.svg";